<template>
  <div id="app">
    <first-Component page="home" style="z-index: 100000"></first-Component>

    <div class="notice" v-if="isSet">
      <p>
        This website uses cookies to improve site functionality and to provide you with a better browsing experience. You can learn more about our use of cookies on the website by reading our
        <a class="a" href="./cookie.html">Cookie Notice</a>. By using this website or clicking OK, you consent to the use of cookies.
      </p>
      <a class="btn" @click="setCookies">OK</a>
    </div>
    <div id="scroller-wrapper" data-scrollbar>
      <four-Component></four-Component>
      <home-Component></home-Component>
    </div>
  </div>
</template>

<script>
import { WOW } from "wowjs";
import Scrollbar from "smooth-scrollbar";
import firstComponent from "@/components/first.vue";
import fourComponent from "@/components/four.vue";
import homeComponent from "@/views/Home.vue";
import Cookies from "js-cookie";
export default {
  name: "home",
  data() {
    return {
      isSet: true,
      noShow: {},
      wow: "",
      scrollbar: ""
    };
  },
  // watch:{
  //   '$route':'init'
  // },
  components: { firstComponent, homeComponent, fourComponent },
  mounted() {
    this.wow = new WOW();
    this.init();
    if (Cookies.get("yizhou") === undefined) {
      this.isSet = true;
    } else {
      this.isSet = false;
    }
    // this.$router.beforeEach((to, from, next) => {
    //   Scrollbar.destroyAll()
    //   next()
    // })
  },
  methods: {
    setCookies() {
      Cookies.set("yizhou", "1");
      this.isSet = false;
    },
    init() {
      this.$nextTick(() => {
        this.scrollbar = Scrollbar.init(
          document.getElementById("scroller-wrapper")
        );
        this.wow.init();
        this.noShow = { display: "block" };
        let scrollbar = Scrollbar.get(
          document.getElementById("scroller-wrapper")
        );
        scrollbar.scrollTo(0, 0);
        window.pageYOffset = this.scrollbar.scrollTop;
        this.scrollbar.addListener(() => {
          this.wow.scrollHandler();
          window.pageYOffset = this.scrollbar.scrollTop;
          if (window.pageYOffset > 0) {
            this.noShow = { display: "none" };
          }
        });
      });
    }
  }
};
</script>
<style>
.notice {
  position: fixed;
  z-index: 1000000;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 100px;
  background: #000000a6;
  transition: 0.4s;
  /* padding: 20px 0; */
  font-family: graphik, sans-serif;
  color: #627482;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.notice p {
  line-height: 20px;
  margin-bottom: 0;
  max-width: 1000px;
  font-family: "Fira Code Light";
  font-weight: lighter;
  margin-left: 40px;
  line-height: 30px;
  color: white;
}
.notice p .a {
  color: #91c131 !important;
  text-decoration-line: underline;
}
.notice .btn {
  display: block;
  height: 40px;
  border: 1px solid #2f4455;
  line-height: 40px;
  padding: 0 60px;
  cursor: pointer;
  margin-right: 40px;
  font-family: "Fira Code Light";
  font-weight: lighter;
  background-color: #91c131;
}
@media screen and (max-width: 1000px) {
  .notice{
    height: auto;
    flex-direction: column;
    padding: 10px;
  }
  .notice p{
    width: 90%;
    margin: 0 auto;
  }
  .scrollbar-thumb {
    display: none;
    width: 1px !important;
    background-color: #888888 !important;
  }
  .scrollbar-track-y {
    display: none !important;
    width: 1px !important;
  }
}
body {
  margin: 0;
  padding: 0;
}
ul,
li,
p,
a {
  margin: 0;
  padding: 0;
  text-decoration: none;
  color: black;
}
.el-input {
  width: 45% !important;
  margin-left: 5%;
  margin-top: 30px;
}
.el-textarea {
  width: 95%;
  margin-left: 5%;
  margin-top: 30px;
}
input:focus {
  border-color: #dcdfe6 !important;
  outline: 0;
}
textarea:focus {
  border-color: #dcdfe6 !important;
  outline: 0;
  resize: none !important;
}
#app {
  font-family: "Open Sans", Arial, sans-serif;
  text-rendering: optimizeLegibility !important;
  hyphens: none !important;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  width: 100%;
  overflow: hidden;
}
#scroller-wrapper {
  position: relative;
  height: 100vh;
  overflow: hidden;
  /* z-index: 101; */
}
.scrollbar-thumb {
  width: 20px !important;
  background-color: #888888 !important;
}
.scrollbar-track-y {
  width: 20px !important;
}
</style>
